export {};
declare global {
    interface String {
        toDate(): Date;
        fromBase64(): ArrayBuffer;
    }
}

if (!String.prototype.toDate) {
    String.prototype.toDate = function toDate(this: string): Date {
        let value = this;

        // If the value matches the ISO format without milliseconds, add them
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(value))
            value = `${value}.000Z`;

        // Try to parse the date
        let temp = new Date(value);

        // If parsing succeeded, return the date
        if (!isNaN(Number(temp))) return temp;

        // Try to parse as DD/MM/YYYY by swapping to MM/DD/YYYY
        temp = new Date(value.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3"));

        if (!isNaN(Number(temp))) return temp;

        // If all parsing fails, return the current date
        return new Date();
    };
}

if (!String.prototype.fromBase64) {
    String.prototype.fromBase64 = function fromBase64(
        this: string,
    ): ArrayBuffer {
        var binary_string = window.atob(
            this.replace(/_/g, "/").replace(/-/g, "+"),
        );
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };
}
